// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cgv-page {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  width: 100%;
  padding: 2rem 3.5rem;
  margin: 0 !important;
}

.cgv-title-h1 {
  color: #ffa500;
}

.cgv-title-h2 {
  color: #ffa500;
}

.cgv-title-h3 {
  color: #ffa500;
}

.cgv-custom-container {
  max-width: inherit !important;
  margin: 0 !important;
}

.cgv-custom-paragraph {
  margin-bottom: 1em;
}

.cgv-custom-ul {
  list-style-type: decimal;
  margin-left: 20px;
}

.cgv-custom-title-h1 {
  color: #ffa500;
}

.cgv-custom-title-h2 {
  color: #ffa500;
}

.cgv-custom-title-h3 {
  color: #ffa500;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Mentions/Mentions.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".cgv-page {\n  font-family: Arial, sans-serif;\n  line-height: 1.6;\n  width: 100%;\n  padding: 2rem 3.5rem;\n  margin: 0 !important;\n}\n\n.cgv-title-h1 {\n  color: #ffa500;\n}\n\n.cgv-title-h2 {\n  color: #ffa500;\n}\n\n.cgv-title-h3 {\n  color: #ffa500;\n}\n\n.cgv-custom-container {\n  max-width: inherit !important;\n  margin: 0 !important;\n}\n\n.cgv-custom-paragraph {\n  margin-bottom: 1em;\n}\n\n.cgv-custom-ul {\n  list-style-type: decimal;\n  margin-left: 20px;\n}\n\n.cgv-custom-title-h1 {\n  color: #ffa500;\n}\n\n.cgv-custom-title-h2 {\n  color: #ffa500;\n}\n\n.cgv-custom-title-h3 {\n  color: #ffa500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
